import { useState, useEffect } from 'react';
import { useStorage } from '@spa/shared/hooks/storage';

const useClickedOffers = (id, version, externalOnClick) => {
  const sessionStorage = useStorage('sessionStorage');
  const readClickedOffers = () => JSON.parse(sessionStorage.getItem('clickedOffers') || '[]');
  const [hasBeenClicked, setHasBeenClicked] = useState(false);

  const handleMarkerClick = () => {
    if (externalOnClick) {
      externalOnClick();
    }

    if (hasBeenClicked) {
      return;
    }

    const clickedOffers = readClickedOffers();
    const newClickedOffers = [...clickedOffers, `${id}-${version}`];
    sessionStorage.setItem('clickedOffers', JSON.stringify(newClickedOffers));
    setHasBeenClicked(true);
  };

  useEffect(() => {
    const clickedOffers = readClickedOffers();
    setHasBeenClicked(clickedOffers.includes(`${id}-${version}`));
  }, []);

  return [hasBeenClicked, handleMarkerClick];
};

export default useClickedOffers;
